import { defineNuxtPlugin, useRuntimeConfig } from '#app';

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.config.errorHandler = (error, instance, info) => {
    if (useRuntimeConfig().public.dev) {
      console.error(error, instance, info);
    }
  };
});
